exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{font-size:16px;position:relative;min-height:100%;--app-height: calc(100vh - var(--announcement-height, 0px))}html,body{margin:0;padding:0}body{font-family:\"Roboto\",sans-serif !important;background-color:#f6f2f7 !important;color:#47464f;height:100vh;overflow:hidden}", ""]);

// exports
